module.exports = __webpack_public_path__ + "assets/2e71a40ea5f9e831a6325c96548ae31f.png";